export default __webpack_public_path__ + "static/media/list-gestalt.167d8f08.svg";